import {useMergeboxStatusCalculator} from '@github-ui/mergebox/use-mergebox-status-calculator'
import {EMPTY_CHANNELS} from '@github-ui/mergebox/use-mergeability-live-updates'
import {useMergeStatusButtonData} from '../../../../hooks/use-merge-status-button-data'
import {useLayoutRouteData} from '../../../../page-data/loaders/use-layout-route-data'

/**
 * Wraps the merge-status calculator pipeline (which also wires up the relevant
 * live updates) and surfaces the conflicts section status plus the pull request
 * payload and viewer permissions that the For You merge conflicts item derives
 * its state from.
 *
 * Returns `null` when there is no validated merge data, in which case consumers
 * should early return so the item is not registered as visible.
 */
export function useValidatedConflictsData() {
  const {pullRequest, mergeStatusButtonData} = useLayoutRouteData()
  const validatedMergeData = useMergeStatusButtonData(pullRequest.state, mergeStatusButtonData)

  // hack: the calculator hook was not built with undefined/null in mind
  const headSha = validatedMergeData?.headSha ?? ''
  const channels = validatedMergeData?.channels ?? EMPTY_CHANNELS

  const {
    calculator,
    pullRequest: mergeBoxPullRequest,
    mergeRequirements,
  } = useMergeboxStatusCalculator({headSha, channels})

  if (!validatedMergeData) return null

  const userStateCondition = mergeRequirements?.conditions.find(
    condition => condition.type === 'PULL_REQUEST_USER_STATE',
  )
  const canUserPushToBase = userStateCondition?.result === 'PASSED'

  return {
    pullRequest: mergeBoxPullRequest,
    conflictsSection: calculator.sections.ConflictsSection,
    canUserPushToBase,
  }
}
